/** Types that are safe to open from a local file: they render as documents/images, never as script. */
const PREVIEWABLE_TYPES = ["application/pdf", "image/png", "image/jpeg"];

/**
 * A blob: URL for previewing a file the applicant just picked, or null when its type is not previewable. A blob: URL has
 * the portal's origin and the browser renders it by the blob's own type, so previewing an applicant-chosen SVG or HTML
 * file would run its script with access to the signed-in session. Only PDF, PNG and JPEG are opened; everything else
 * is uploaded as usual but gets no local preview.
 */
export const createSafePreviewUrl = (file: File): string | null =>
    PREVIEWABLE_TYPES.includes(file.type) ? URL.createObjectURL(file) : null;
